import ModalBase, { IModalBaseProps, ModalBaseRefType } from "@/Components/Base/ModalBase";
import { TypeInscricaoDoAlunoNaViagem } from "@/Models/Domain/Viagem/InscricaoDoAlunoNaViagem";
import { Button, ButtonProps, Form, notification, Popconfirm, PopconfirmProps, Typography } from "antd";
import { createRef, useRef } from "react";
import InscricaoProvedorPgtoForm from "./InscricaoProvedorPgtoForm";
import { useInscricaoAlterarProvedor } from "@/Services/Domain/Viagem/InscricaoService";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import { IInscricaoProvedorPgtoInscricaoParamsFormType } from "./InscricaoProvedorPgtoFormBasic";
import { useTituloGerarLink } from "@/Services/Financeiro/Titulo/TituloService";

export interface IInscricaoProvedorPgtoFormPopConfirmProps extends Partial<IModalBaseProps> {
    inscricao : TypeInscricaoDoAlunoNaViagem;
}
export default function InscricaoProvedorPgtoFormPopConfirm({
    title,
    textButtonOpen,
    propsButtonOpen,
    width,
    destroyOnClose,
    ...rest
}: IInscricaoProvedorPgtoFormPopConfirmProps) {
    const refModal = useRef<ModalBaseRefType|null>(null);
    const [form] = Form.useForm<IInscricaoProvedorPgtoInscricaoParamsFormType>();
    
    const {
        isPending,
        mutate
    } = useInscricaoAlterarProvedor({
        onSuccess(data, variables, context) {
            refModal.current?.fechar?.();
            notification.success(PropriedadesDeNotificacao.Sucesso("Pagamento gerado com sucesso."));
        }
    });

    return <ModalBase
        {...rest}
        ref={refModal}
        title={title ?? "Alterar provedor de pagamento"}
        textButtonOpen={textButtonOpen ?? "Provedor Pgto."}
        propsButtonOpen={propsButtonOpen ?? {
            size: "middle",
            type: "dashed"
        } as ButtonProps}
        width={width}
        destroyOnClose={destroyOnClose ?? true}
        confirmLoading={isPending}
        footer={[
            <Button
                key="cancelar"
                size="small"
                danger
                onClick={() => refModal.current?.fechar?.()}
                loading={isPending}
            >Cancelar</Button>,
            <Button
                key="inscricao-provedor-pgto-alterar"
                type="primary"
                size="small"
                onClick={() => {
                    form.submit();
                }}
                loading={isPending}
            >Salvar</Button>
        ]}
    >
        <InscricaoProvedorPgtoForm  
            form={form}
            onFinish={(values) => mutate(values)}
            codInscricao={rest.inscricao.codigo!}
        />
    </ModalBase>;
}